import { useMutation, useQueryClient } from '@tanstack/react-query';
import { client, getUserData, setUserData } from '../../lib/client';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

interface LeaveGroupResponse {
  success: boolean;
  message: string;
}

const leaveGroup = async (groupId: string): Promise<LeaveGroupResponse> => {
  const response = await client.delete(`/groups/${groupId}/leave`);
  return response.data;
};

export const useLeaveGroup = () => {
  const queryClient = useQueryClient();
  const user = getUserData();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: leaveGroup,
    onSuccess: (_, groupId) => {
      queryClient.invalidateQueries({ queryKey: ['userGroups', user?.id] });
      
      if (user?.primary_group_id === groupId) {
        setUserData({
          ...user,
          primary_group_id: null
        });
        queryClient.invalidateQueries({ queryKey: ['profile'] });
      }
      
      toast.success('그룹에서 나갔습니다.', {
        icon: '👋',
      });
      navigate('/groups', { replace: true });
    },
    onError: (error: any) => {
      console.error('그룹 나가기 실패:', error);
      toast.error(error.response?.data?.error || '그룹 나가기에 실패했습니다.', {
        icon: '❌',
      });
    },
  });
};
